import { render } from "./App.vue?vue&type=template&id=1bc43e7a&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1bc43e7a&lang=scss"
import "./App.vue?vue&type=style&index=1&id=1bc43e7a&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc43e7a"]])

export default __exports__